<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoTitulo",
    :conteudo="conteudoModal",
    :isProcesso="true"
  )

  app-modal-analise-conjunta(
    v-if="showModalDespachoReurb",
    :idsProcessos="idsProcessosAssinatura",
    :showModal="showModalDespachoReurb"
    :analiseSemDespacho="analiseSemDespacho"
    titulo='Modelos de Despacho Dinâmico',
    :tiposModelo="[4]"
    @closeModal="closeModalDespachoReurb"
    @cancelModal="closeModalDespachoReurb"
    @confirm="confirmarModelo"
    @filtro="closeModalDespachoReurb"
    @cancelaTramitacao="cancelaTramitacao"
  )

  app-modal-assinatura-conjunta(
    v-if="showModalAssinatura",
    :idsProcessos="idsProcessosAssinatura",
    :showModal="showModalAssinatura"
    :analiseSemDespacho="analiseSemDespacho"
    titulo='Assinatura',
    :tiposModelo="[4]"
    @closeModal="closeModalAssinatura"
    @cancelModal="cancelModalAssinatura"
    @confirm="confirmarModelo"
    @filtro="closeModalAssinatura"
    @cancelaTramitacao="cancelaTramitacao"
    @atualizarListagem="atualizarListagem"
  )

  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )

  app-modal-regerar(
    v-if="showModalRegerar && idsProcessos.length > 0",
    @closeModal="showModalRegerar = false",
    :idsProcessos="idsProcessos"
  )

  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
      :showButtonPesquisaLote="true"
      @retornoPesquisaLote="atualizaBuscaLote"
    )
  app-listagem(
    ref="appListagem",
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="showButtonAssinatura()",
    :textoButtonAssinatura="textoButtonAssinatura",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="Array.isArray(items) ? items : [items]",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :filtro="filtro"
    :pagina="filtro.pagina",
    :hasMultipleCheckbox="enableSelectAll()"
    :hasRefreshMounted="false"
    @updateListagem="refreshTable",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selectAll="selectItems",
    @selecionaIds="selecionaIds"
    @assinarTitulos="funcaoModal"
    @regerar="REGERAR_PROCESSOS"
    :showButtonRegerar="showButtonRegerar()"
    @retornoPesquisaLote="atualizaBuscaLote"
  )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalAnaliseConjunta from '@/screens/analise/components/modal/AppModalAnaliseConjunta'
import AppModalAssinaturaConjunta from '@/screens/analise/components/modal/AppModalAssinaturaConjunta'
import AppModalVisualizaPdf from '../components/AppModalVisualizaPdf'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalRegerar from '@/screens/analise/components/modal/AppModalRegerar'
const { filtro, verificarDespachoSemTexto, montarListagem, isGcgCgir, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalVisualizaPdf,
    AppModalAnaliseConjunta,
    AppModalAssinaturaConjunta,
    AppModalRegerar
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      textoButtonAssinatura: montarListagem[this.$route.name].textoButtonAssinatura,
      funcaoModal: this[montarListagem[this.$route.name].funcaoExibirModal],
      filtro: FILTRO_EMPTY(this.$route.name),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      numeroProcesso: null,
      protocolo: null,
      documentoSelecionado: null,
      idProcesso: null,
      tipoProcesso: null,
      showModalVisualizaPdf: false,
      showModalVisualizarProcesso: false,
      idsProcessosAssinatura: [],
      showModalDespachoReurb: false,
      showModalAssinatura: false,
      idTitulo: null,
      tipoTitulo: null,
      tituloModal: null,
      conteudoModal: null,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.ANALISE_COLETIVA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.ANALISE_COLETIVA || [],
        filtroReceita: filtro?.filtroReceita?.ANALISE_COLETIVA || [],
        filtroMunicipio: filtro?.filtroMunicipio?.ANALISE_COLETIVA || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.ANALISE_COLETIVA || [],
        filtroFuncao: filtro?.filtroFuncao?.ANALISE_COLETIVA || [],
        filtroDataVencimento: filtro?.filtroDataVencimento?.ANALISE_COLETIVA || [],
        filtroRua: filtro?.filtroRua?.ANALISE_COLETIVA || [],
        filtroBairro: filtro?.filtroBairro?.ANALISE_COLETIVA || [],
        filtroRemessa: filtro?.filtroRemessa?.ANALISE_COLETIVA || [],
        filtroQuadra: filtro?.filtroQuadra?.ANALISE_COLETIVA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => true, ordem: 1, acoes: [] },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso }
          ]
        }
      ],
      usuario: null,
      showModalRegerar: false,
      idsProcessos: [],
      showFiltroTipoMultiplo
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    analiseSemDespacho () {
      return verificarDespachoSemTexto(this.usuario)
    },
    isPa () {
      return process.env.ESTADO === 'pa'
    },
    isMa () {
      return process.env.ESTADO === 'ma'
    },
    isBa () {
      return process.env.ESTADO === 'ba'
    },
    isDeaf () {
      return this.usuarioLogado.perfilSelecionado.setor.codigo === 'DEAF'
    },
    isSetorGcgCgir () {
      return this.usuarioLogado.perfilSelecionado.setor.codigo === 'GCG_CGIR'
    },
    isDj () {
      return this.usuarioLogado.perfilSelecionado.setor.codigo === 'DJ'
    },
    isGeo () {
      return this.usuarioLogado.perfilSelecionado.setor.codigo === 'GEO'
    },
    isDiretorDj () {
      return this.usuarioLogado.perfilSelecionado.codigo === 'DIRETOR_JURIDICO_DJ'
    },
    isDrf () {
      return this.usuarioLogado.perfilSelecionado.codigo === 'DIRETOR_DRF'
    },
    isComissaoIlha () {
      return this.usuarioLogado.perfilSelecionado.codigo === 'CHEFE_SETOR_COMISSAO_ILHA'
    },
    isCoordenadorNaj () {
      return this.usuarioLogado.perfilSelecionado.codigo === 'COORDENADOR_NAJ'
    },
    isSuperintendenteGab () {
      return this.usuarioLogado.perfilSelecionado.codigo === 'SUPERINTENDENTE_GAB'
    },
    isCoordenadorCaf () {
      return this.usuarioLogado.perfilSelecionado.codigo === 'COORDENADOR_CAF'
    }
  },

  async created () {
    this.init()
    this.usuario = await this.usuarioLogado
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {

    ...mapActions({
      regerar: 'filaAnaliseAutomatizada/regerar'
    }),

    async atualizarListagem () {
      await this.refresh(this.filtro)
    },
    ASSINAR () {
      if (this.processosSelecionados.length > 0) {
        this.idsProcessosAssinatura = this.processosSelecionados.map(p => p.id)
        this.showModalAssinatura = true
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          this.$messages.SELECIONA_MINIMO_PROCESSO)
      }
    },
    ASSINAR_TITULOS () {
      if (this.processosSelecionados.length > 0) {
        this.idsProcessosAssinatura = this.processosSelecionados.map(p => p.id)
        this.showModalDespachoReurb = true
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          this.$messages.SELECIONA_MINIMO_PROCESSO)
      }
    },
    REGERAR_PROCESSOS (ids) {
      if (ids.length > 0) {
        this.confirmBox(this.$messages.AVISO_REGERAR, this.$messages.TITULO_WARNING,
          async () => {
            await this.regerar(ids)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) enviados para a Fila')
            this.refreshTable()
            this.$router.push({
              name: 'EM_ANALISE'
            })
          },
          () => { }
        )
      }
    },
    setTextoNotificacao (textoNotificacao) {
      this.$refs.editorTexto.text = textoNotificacao
      this.$refs.editorTexto.emitTextChange()
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    async closeModalAssinatura () {
      this.showModalAssinatura = false
      await this.refreshTable()
      if (this.$refs.appListagem) {
        this.$refs.appListagem.clearListaIDs()
      }
    },
    async cancelModalAssinatura () {
      this.showModalAssinatura = false
      await this.refreshTable()
      if (this.$refs.appListagem) {
        this.$refs.appListagem.clearListaIDs()
      }
    },
    closeModalDespachoReurb () {
      //  this.filtro = FILTRO_EMPTY('ANALISE_COLETIVA')
      this.showModalDespachoReurb = false
      this.processosSelecionados = []
      this.idsProcessosAssinatura = []
      this.init()
    },
    selectItems (itens) {
      this.processosSelecionados = itens
      itens.forEach(processo => {
        this.idsProcessos.push(processo.id)
      })
    },
    selecionaIds (itens) {
      this.processosSelecionados = itens.map(id => { return { id } })
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },
    confirmarModelo (idDocumento) {
      this.documentoSelecionado = idDocumento
      this.showModalDespachoReurb = false
    },
    cancelaTramitacao () {
      this.showModalDespachoReurb = false
    },
    async refreshTable () {
      await this.refresh(this.filtro)
      this.items = this.items.map(item => ({...item, selecionado: false}))
      this.idsProcessosAssinatura = []
      this.processosSelecionados = []
    },
    showButtonRegerar () {
      return this.isPa ? false : isGcgCgir(this.usuario?.perfilSelecionado?.setor?.codigo)
    },
    showButtonAssinatura () {
      return (this.isPa || this.isMa || this.isBa) && (this.isDeaf || this.isSetorGcgCgir || (this.isDj && this.isDiretorDj) || this.isGeo || this.isDrf || this.isComissaoIlha || this.isCoordenadorNaj || this.isSuperintendenteGab || (this.isCoordenadorCaf && this.isBa))
    },
    atualizaBuscaLote (novosItems) {
      this.items = novosItems.content
    },
    enableSelectAll () {
      return (this.isPa || this.isMa) && (this.isSetorGcgCgir || (this.isDj && this.isDiretorDj) || this.isDeaf || this.isGeo || this.isDrf || this.isComissaoIlha)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAssinaturasLaudoListagem.vue